import EnvironmentUtils from '@/utils/environmentUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import DOMUtils from '@/utils/DOMUtils'

/**
 * @param {Function} notificationOpenedCallback 
 */
async function initialize (notificationOpenedCallback)
{
    console.log('Initializing OneSignal with app ID', LocalStorageUtils.cityManifest.oneSignalAppId)

    if (cordova.platformId == 'browser' && EnvironmentUtils.isProductionEnv)
    {
        await initializeBrowser()
    }
    else
    {
        await initializeMobile(notificationOpenedCallback)
    }
}

async function initializeMobile (notificationOpenedCallback)
{
    if (window.plugins.OneSignal.setAppId)
    {
        window.plugins.OneSignal.setLogLevel(6, 0)
        window.plugins.OneSignal.setAppId(LocalStorageUtils.cityManifest.oneSignalAppId)
        window.plugins.OneSignal.setNotificationOpenedHandler(notificationOpenedCallback)
        window.plugins.OneSignal.promptForPushNotificationsWithUserResponse(function(accepted) {
            console.log('User accepted notifications: ' + accepted);
        });
    }
    else
    {
        window.plugins.OneSignal.setLogLevel({logLevel: 6, visualLevel: 0})
        
        window.plugins.OneSignal
        .startInit(LocalStorageUtils.cityManifest.oneSignalAppId)
        .handleNotificationOpened(notificationOpenedCallback)
        .inFocusDisplaying(window.plugins.OneSignal.OSInFocusDisplayOption.Notification)
        .endInit()
    }
}

async function initializeBrowser ()
{
    console.log('Production browser dectected, downloading OneSignal browser SDK.')

    window.OneSignal = []
    await DOMUtils.appendScriptElem('https://cdn.onesignal.com/sdks/OneSignalSDK.js')
    console.log('OneSignal Web SDK downloaded')

    window.OneSignal.push(() =>
        window.OneSignal.init
        ({
            appId: LocalStorageUtils.cityManifest.oneSignalAppId,
            safari_web_id: LocalStorageUtils.cityManifest.oneSignalSafariWebId,
            path: '/static/libs/OneSignal/'
        })
    )
}

async function getUserId ()
{
    return new Promise(resolve =>
    {
        if (cordova.platformId == 'browser')
        {
            if (!window.OneSignal.getUserId)
            {
                if (!EnvironmentUtils.isProductionEnv)
                {
                    return resolve('817a6eb9-2c7d-4e52-9807-b69485a5197e')
                }

                return resolve(null)
            }

            return window.OneSignal.getUserId().then(resolve)
        }
        else
        {
            if (window.plugins.OneSignal.setAppId)
            {
                window.plugins.OneSignal.getDeviceState(s => resolve(s.userId))
            }
            else
            {
                window.plugins.OneSignal.getPermissionSubscriptionState(s => resolve(s.subscriptionStatus.userId))
            }
        }
    })
}

export default { initialize, getUserId }


// WEBPACK FOOTER //
// ./src/utils/oneSignalUtils.js